<template>
  <div id="app">
    <div v-show="showTip" id="weixinTip" ref="weixin" class="wxtip">
      <p class="wxtip-txt">
        在微信中无法进行浏览
        <br/>
        1. 请点击右上角按钮
        <br/>
        2. 选择【在浏览器中打开】
      </p>
    </div>
    <router-view v-wechat-title='$route.meta.title'></router-view>
  </div>
</template>
<script>
const {userAgent} = navigator

export default {
  components: {},
  data: function () {
    return {
      // 是否显示遮罩
      showTip: true,
    };
  },
  created: function () {
    this.showTip = !!/MicroMessenger/i.test(userAgent)
  },
  methods: {}
}

</script>
<style scoped>
.wxtip {
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}

img {
  width: 100%;
}

.wxtip-txt {
  margin-top: 107px;
  color: #fff;
  font-size: 20px;
  line-height: 1.8;
}
</style>
